import React from 'react';

const FeatureUnavailable = () => {
  return (
    <div className="feature-unavailable">
      <h2>Feature Unavailable</h2>
      <div>You do not have permission to use this feature. Please contact your administrator</div>
    </div>
  );
};

export default FeatureUnavailable;
